const state = {
  sliders: [
    {player: 'player_1', color: 'deep-purple-2'},
    {player: 'player_2', color: 'teal-2'},
    {player: 'player_3', color: 'pink-2'},
    {player: 'player_4', color: 'deep-orange-2'}
  ]
}
const mutations = {
  toSanma (state, val) {
    state.sliders = [
      {player: 'player_1', color: 'deep-purple-2'},
      {player: 'player_2', color: 'teal-2'},
      {player: 'player_3', color: 'pink-2'}
    ]
  },
  toYonma (state, val) {
    state.sliders = [
      {player: 'player_1', color: 'deep-purple-2'},
      {player: 'player_2', color: 'teal-2'},
      {player: 'player_3', color: 'pink-2'},
      {player: 'player_4', color: 'deep-orange-2'}
    ]
  }
}
const actions = {
  buttonAction ({ commit, state, rootState }) {
    console.log('buttonAction')
  }
}
const getters = {
  getSliders (state, getters, rootState) {
    return state.sliders
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/TheScoreSlider.js